module.exports = function() {
    // global functionality goes here

    const $body = $('body'),
        $header = $('header.masthead');

    $body.addClass('jsenabled');


    // check if browser is IE - if true, add body class
    const isIE = navigator.appName === 'Microsoft Internet Explorer' ||
        !!(navigator.userAgent.match(/Trident/) ||
        navigator.userAgent.match(/rv:11/)) ||
        (typeof $.browser !== "undefined" && $.browser.msie === 1);

    if (isIE) {
        $body.addClass('browser-ie');
    }

    // check if browser is iOS (Apple mobile device) - if true, add body class
    const isIOS = (/iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
        !window.MSStream;

    if (isIOS) {
        $body.addClass('browser-ios');
    }


    // check if dbkdev, add body class
    const currentURL = window.location.href;
    if (currentURL.indexOf('.dbkdev.nl') > -1 || currentURL.indexOf('localhost') > -1 || currentURL.indexOf('.test') > -1) {
        $body.addClass('dbkdev');
    }


    // push gtm-event data-values on anchors to datalayer
    $body.on( 'click', '[data-gtm-event]', function() {
        let gtm_event = $(this).data('gtm-event');
        let page_url = $(location).attr('href');

        /*
        console.log({
            'event': 'dbk_gtm_event',
            'event_label': gtm_event,
            'event_url': page_url
        }); // development */

        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                'event': 'dbk_gtm_event',
                'event_label': gtm_event,
                'event_url': page_url
            }); // production
        }
    });


    // prevent disabled buttons to execute default actions
    $('.btn-disabled').click( function(e) {
        e.preventDefault();
    });


    // unfocus links after click
    $body.on('click', 'a, button', function () {
        $(this).blur();
    });


    // init lightbox
    $('a.lightbox').nivoLightbox({
        afterShowLightbox: function(){
            let $iframe = $('.nivo-lightbox-content > iframe'),
                src = $iframe.attr('src');

            $iframe.attr('src', src + '?autoplay=1&rel=0&disablekb=1&fs=0');
        }
    });


    // init tooltips
    $body.tooltip({
        selector: '[data-toggle="tooltip"]',
        container: 'body'
    });

    // init popovers
    $body.popover({
        // trigger: 'click',
        selector: '[data-toggle="popover"]',
        trigger: 'hover',
        html: true,
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    });


    // toggle-menu
    $('#toggle-menu').click( function(e) {
        e.preventDefault();
        if ( $body.hasClass('show-menu') ) {
            $body.removeClass('show-menu');
        } else {
            $body.addClass('show-menu');
        }
    });
    // close menu
    $('#close-mobile-nav').click( function(e) {
        e.preventDefault();
        if ( $body.hasClass('show-menu') ) {
            $body.removeClass('show-menu');
        }
    });


    // when a link is clicked with href attribute starting with #, scroll that shit smoothly (if target exists)
    $body.on('click', 'a[href^="#"]', function() {
        let $this = $(this);
        let target = $(this).attr('href');
        let scrollOffset = $header.outerHeight();

        // check if target is more than just a # dummy link
        if (target.length > 1) {

            // check if target is a complete url instead of only #id, if so, extract ID part
            if (!target.startsWith('#')) {
                target = '#'+ target.split('#').pop();
            }

            if ( $this.data('extra-scroll-offset') ) {
                 scrollOffset = scrollOffset + $(this).data('extra-scroll-offset');
            }

            // if target exists
            if ( $(target).length > 0 ) {

                // if target has top margin, add half of it to scroll offset
                let targetMargin = parseInt($(target).css('marginTop'));

                if (targetMargin > 0) {
                    scrollOffset = scrollOffset + (targetMargin / 2);
                }

                let targetOffset = $(target).stop().offset().top - scrollOffset;

                if (targetOffset > $(document).scrollTop()) {
                    // if scroll direction is down, remove masthead height from offset (because sticky masthead is only visible when scrolling up)
                    targetOffset = targetOffset + $header.outerHeight();
                }

                $('html, body').animate({
                    scrollTop: targetOffset
                }, 1000, 'easeInOutCubic', function() {
                    $this.blur();
                });
            }
        }
    });


    // insert check icon elements to ul.list-checked in content-wrapper
    $('.content-wrapper .list-checked > li').each( function() {
        $(this).prepend('<i class="item-icon far fa-check"></i>');
    });


    $('.next-section-button').on('click', function(e) {
        e.preventDefault();

        let $this = $(this),
            $nextSection = $(this).closest('.section').next('.section'),
            scrollOffset = 0; // $header.outerHeight();

        if ($nextSection.length > 0) {

            // if target has top margin, add half of it to scroll offset
            let targetMargin = parseInt($nextSection.css('marginTop'));

            if (targetMargin > 0) {
                scrollOffset = scrollOffset + (targetMargin / 2);
            }

            $('html, body').animate({
                scrollTop: $nextSection.stop().offset().top - scrollOffset
            }, 1000, 'easeInOutCubic', function() {
                $this.blur();
            });
        }
    });


    // when escape key is pressed
    $(document).keyup(function(e) {
        if (e.key === "Escape") { // escape key maps to keycode `27`
            if ( $body.hasClass('show-menu') ) {
                $body.removeClass('show-menu');
            }
        }
    });

    // load extra JS parts
    require('./html-videos');
    require('./gravity-forms');
    require('./sticky-masthead');
    require('./responsive-video');
    require('./sliders');
    require('./fancy-video');
    require('./scroll-to-top');
    require('./expandable-items');
    require('./calculator');
    require('./custom-range');
    require('./custom-steps');
    require('./custom-select');
    require('./booking');
    require('./fh-buttons');
    require('./fareharbor');
    require('./dbk-lightbox');
    require('./map');
    require('./catering-blocks');
    require('./modals');
    require('./mobile-overlay-button');
    require('./faq-search');
    require('./nofollow');
    require('./table-of-contents');
    require('./read-more-button');
    require('./tabs');
    require('./countdown');

};